<template>
  <section class="career-inner">
    <div class="main-header">
      <div class="container-2 fade-up" v-in-viewport.once>
        <div @click="goBack()" class="back pointer">
          <IconComponent name="arrow-right" />
          <p>{{ $fn.tr("back") }}</p>
        </div>

        <h2 class="font-55">{{ _.get(data, "title") }}</h2>
        <div class="date">
          <p class="f-medium">{{ $fn.tr("Published:") }} {{ published }}</p>
          <p class="f-medium">{{ $fn.tr("Deadline:") }} {{ deadline }}</p>
        </div>

        <p class="type" v-if="_.get(data, 'jobtype')">
          {{ _.get(data, "jobtype") }}
        </p>
      </div>
    </div>
    <div class="main-content">
      <div class="container-2 fade-up" v-in-viewport.once>
        <h3 class="font-34" v-if="_.get(data, 'description')">
          {{ _.get(data, "description") }}
        </h3>
        <div class="text" v-html="_.get(data, 'full_description.tabs.0.content')"></div>
        <a
          :href="_.get(contentData, 'data.list.0.url.url')"
          target="_blank"
          v-if="_.get(contentData, 'data.list.0.url') !== ''"
        >
          <button class="pointer">
            {{ $fn.tr("Apply") }}
          </button>
        </a>

        <div class="share-with-friends">
          <p class="font-16">{{ $fn.tr("Share With Friend") }}</p>
          <div class="share-box" key="share-options">
            <template v-for="(icon, index) in getShareLinks">
              <div
                class="share-icon pointer"
                v-html="icon.svg"
                :key="index"
                @click.stop="openSharePopup(icon.url)"
                target="_blank"
                :href="icon.url"
              ></div>
            </template>
          </div>
          <div @click="goBack()" class="back pointer">
            <IconComponent name="arrow-right" />
            <p>{{ $fn.tr("back") }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import IconComponent from "../IconComponent.vue";
import moment from "moment";

export default {
  props: ["contentData"],

  components: {
    IconComponent
  },
  computed: {
    getShareLinks() {
      let socialList = [];

      let socialSvgs = _.get(
        this.$store.state.main.indx,
        "widgets.social_icons"
      );

      let uri = encodeURI(
        window.location.protocol +
          "//" +
          window.location.host +
          "" +
          this.$route.path +
          window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri
        });
      }

      return socialList;
    },
    data() {
      return _.get(this.contentData, "data.list[0]");
    },
    published() {
      return moment(_.get(this.contentData, "data.list[0].date")).format(
        "DD/M/YYYY"
      );
    },
    deadline() {
      return moment(_.get(this.contentData, "data.list[0].deadline")).format(
        "DD/M/YYYY"
      );
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    }
  }
};
</script>
<style lang="scss">
.career-inner {
  .main-header {
    padding: 34px 0 55px;
    background: var(--thirdy-tranparent);
    h2 {
      color: var(--bonus-txt);
      margin: 34px 0 20px;
      @media (max-width: 1365px) {
        font-size: 34px;
      }
    }
    .type {
      margin-top: 34px;
    }
  }
  p {
    color: var(--bonus-txt);
  }
  .text p {
    margin-bottom: 30px;
  }
  .back {
    display: flex;
    align-items: center;
    width: fit-content;
    svg {
      margin-top: 5px;
      margin-right: 10px;
      transform: rotate(180deg);
      path {
        fill: var(--bonus-txt);
      }
    }

    &:hover {
      p {
        color: var(--secondary);
      }
      svg {
        path {
          fill: var(--secondary);
        }
      }
    }
  }
  .main-content {
    padding: 55px 0;
    h3 {
      color: var(--bonus-txt);
      width: fit-content;
      margin-bottom: 55px;
      @media (max-width: 1365px) {
        font-size: 21px;
      }
    }
    .text {
      margin-bottom: 20px;
    }
    button {
      @include defBut(
        var(--primay-button-bg),
        var(--bonus-txt3),
        var(--secondarty-transparent),
        var(--white-button-txt2)
      );
    }
    .share-with-friends {
      display: flex;
      align-items: center;
      border-top: 1px solid var(--border);
      padding-top: 34px;
      margin-top: 34px;
      width: 100%;
      .back {
        margin-left: auto;
      }
      .share-box {
        display: flex;
        .share-icon {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
